<template>
  <div>
    <title-edit header="Membership Main" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Name TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_th" @update="updateNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Name EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_en" @update="updateNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
<!--    <div class="row">-->
<!--      <v-col cols="12" sm="3" class="label">-->
<!--        <label>Video url :</label>-->
<!--      </v-col>-->
<!--      <v-col cols="12" sm="8" xs="12">-->
<!--        <input-text-field :model="form.video_url" @update="updateVideoUrl" />-->
<!--      </v-col>-->
<!--    </div>-->
<!--    <div class="row">-->
<!--      <v-col cols="12" sm="3" class="label">-->
<!--        <label>Slide Image :</label>-->
<!--        <div style="color: #2E8037; font-size: 12px">-->
<!--          *รองรับ JPEG ,PNG ขนาดไฟล์ 1,200 x 675 px-->
<!--        </div>-->
<!--      </v-col>-->
<!--      <v-col cols="6" sm="8">-->
<!--        <v-row>-->
<!--          <v-col v-for="(image, index) in form.slide_images" :key="index" cols="4">-->
<!--            <v-card @click="removeSlideImage(index)">-->
<!--              <v-img-->
<!--                :src="image.slide_images_show"-->
<!--                title="click for remove image"-->
<!--                width="150px"-->
<!--                height="150px"-->
<!--              />-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--        <input-image-upload-->
<!--          id="image"-->
<!--          menu="membership"-->
<!--          path="mainpage"-->
<!--          @update="updateSlideImage"-->
<!--          width="140px"-->
<!--          height="140px"-->
<!--        />-->
<!--      </v-col>-->
<!--    </div>-->
    <line-hr />
    <div class="row text-right"
         v-if="permissionMembership && permissionMembership.permission_id === permission.readWrite"
    >
      <v-spacer></v-spacer>
<!--      <preview-button />-->
      <save-button @click.native="save" />
    </div>
<!--        <pre>{{form}}</pre>-->
  </div>
</template>

<script>
import SaveButton from "../../components/Button/SaveButton";
import PreviewButton from "../../components/Button/PreviewButton";
import DeleteButton from "../../components/Button/DeleteButton";
import LineHr from "../../components/Icon/line-hr";
import TitleEdit from "../../components/TitleHeader/TitleEdit";
import InputTextField from "../../components/Input/InputTextField";
import SelectOption from "../../components/Input/selectOption";
import InputEditor from "../../components/Input/InputEditor";
import InputTextArea from "../../components/Input/InputTextArea";
import InputImageUpload from "../../components/Input/InputImageUpload";
import { mapState } from "vuex";
import {permissionMembership, role} from "../../util/Permission";
import Swal from 'sweetalert';

export default {
  name: "MembershipMain",
  components: {
    InputImageUpload,
    InputTextArea,
    InputEditor,
    SelectOption,
    InputTextField,
    TitleEdit,
    LineHr,
    DeleteButton,
    PreviewButton,
    SaveButton
  },
  data() {
    return {
      permission : null,
    };
  },
  computed: {
    permissionMembership,
    ...mapState({
      form: state => {
        return state.MainPage.form;
      }
    })
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("MainPage/showMainPage" , 'membership').then(res => {
        if(res.response_code == 200){
          this.$store.dispatch("MainPage/setFormFreePage", res.result);
        } else {
          Swal('',res.response_msg,'error');
        }
      });
    },
    validateSave() {
      if (!this.form.name_th) {
        Swal('','Please insert Name TH !','error');
        return false;
      } else if (!this.form.name_en) {
        Swal('','Please insert Name EN !','error');
        return false;
      } else if (!this.form.description_th) {
        Swal('','Please insert Description TH !','error');
        return false;
      } else if (!this.form.description_en) {
        Swal('','Please insert Description EN !','error');
        return false;
      } else {
        return true;
      }
    },
    save() {
      this.$store
        .dispatch("MainPage/saveMainPage", {
          id: this.form.id,
          data: this.form
        })
        .then(res => {
          Swal(res.response_msg);
        })
        .catch(() => {
          Swal('','Cannot save membership data','error');
        });
    },
    updateNameTH(val) {
      this.form.name_th = val;
    },
    updateNameEN(val) {
      this.form.name_en = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateVideoUrl(val) {
      this.form.video_url = val;
    },
    updateSlideImage(val) {
      let slide_images_show = val.fullImagePath;
      let slide_images = val.imagePath;
      let data = {
        slide_images_show,
        slide_images
      };
      this.$store.dispatch("MainPage/insertSlideImage", data);
    },
    removeSlideImage(index) {
      this.$store.dispatch("MainPage/removeSlideImage", index);
    },
  }
};
</script>

<style scoped>
@import "../../assets/css/switch.css";
</style>
